<template>
    <div class="body">
        <img src="../assets/verify.png" class="img"><br>
        <h1 class="title">Get Verified</h1>
        <p class="subtitle">Give potential lenders the confidence they need to say yes.</p>
        <div class="feature columns is-vcentered is-mobile">
            <div class="column is-narrow">
                <md-icon class="md-size-3x icon">check_circle_outline</md-icon>
            </div>
            <div class="column has-text-left">
                <h1 class="is-size-5 weight-500">Verified Badge</h1>
                <p>Let lenders know you're legit with your identity and address verified by us.</p>
            </div>
        </div>
        <div class="feature columns is-vcentered is-mobile">
            <div class="column is-narrow">
                <md-icon class="md-size-3x icon">double_arrow</md-icon>
            </div>
            <div class="column has-text-left">
                <h1 class="is-size-5 weight-500">Priority Posts</h1>
                <p>As a Verified User, your posts are displayed first and more frequently.</p>
            </div>
        </div>
        <div class="feature columns is-vcentered is-mobile">
            <div class="column is-narrow">
                <md-icon class="md-size-3x icon">money</md-icon>
            </div>
            <div class="column has-text-left">
                <h1 class="is-size-5 weight-500">Trust Score</h1>
                <p>Get a Trust Score to let lenders know that their money is good with you.</p>
            </div>
        </div>
        <div class="feature columns is-vcentered is-mobile">
            <div class="column is-narrow">
                <md-icon class="md-size-3x icon">credit_card</md-icon>
            </div>
            <div class="column has-text-left">
                <p class="is-size-7 has-text-grey">Coming in 2020</p>
                <h1 class="is-size-5 weight-500">eWallet with Visa virtual card</h1>
                <p>Easily receive funds with thousands of cash-in points nationwide. Spend online with an included Visa virtual prepaid card.</p>
            </div>
        </div>
        <md-card class="cta-card">
            <md-card-header>
                <p class="is-size-4 weight-500">Be among the first Verified Users</p>
            </md-card-header>
            <md-card-content>
                <p class="is-size-6">Join the waitlist now — we only have limited slots.</p>
                <b-button tag="a" href="https://julianpatdu1.typeform.com/to/SyFkG2" target="_blank"
                          class="cta-btn" type="is-primary" size="is-large" expanded>
                    <p class="has-text-white is-size-5 weight-500">Verify Me </p>
                    <b-tag class="cta-price">₱279 for 3 mos.</b-tag>
                </b-button>
                <p class="is-size-7">We'll text you when there's availability</p>
                <p class="is-size-7">Membership starts only when you get your badge</p>
            </md-card-content>
        </md-card>
        <md-button class="decline" @click="decline">No thanks</md-button>
    </div>
</template>

<script>
    import BButton from "buefy/src/components/button/Button";
    import BTag from "buefy/src/components/tag/Tag";
    export default {
        name: "getVerified",
        components: {BTag, BButton},
        methods: {
            // TODO: Make method to request for verified status
            decline() {
                const vm = this;
                let to = vm.$route.query.to;
                if (to) {
                    vm.$router.push({name: to})
                } else {
                    vm.$router.push({name: 'home'})
                }
            }
        }
    }
</script>

<style scoped>
    .body {
        padding: 28px;
    }

    .img {
        height: 156px;
        margin: 14px 0;
    }

    .weight-500 {
        font-weight: 500;
    }

    .icon {
        color: #00a86b !important;
    }

    .cta-card {
        padding: 4px;
        margin: 18px 0;
        -webkit-border-radius: 12px;
        -moz-border-radius: 12px;
        border-radius: 12px;
    }

    .cta-btn {
        margin-top: 14px;
        margin-bottom: 28px;
        padding-top: 32px;
        box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px, rgba(0, 0, 0, 0.024) 0px -6px 16px -6px;
        font-family: "Work Sans", sans-serif;
    }

    .cta-price {
        position: relative;
        top: -6px !important;
        box-shadow: rgba(50, 50, 93, 0.11) 0px 4px 6px 0px, rgba(0, 0, 0, 0.08) 0px 1px 3px 0px;
    }
</style>